import{_ as r}from"./_rollupPluginBabelHelpers-87fa6da4.js";import{coreDefaultTheme as e}from"@kite-js/theme";var a=r(r({},e.card),{},{borderRadius:"NONE",borderWidth:"1px"});export{a as default};
